import type { ChatRoomsSliceState, ScrollInfo } from "../types";

export interface MessageUIActions {
  setActiveMessageId: (uuid: string, id: string | null) => void;
  setFirstMessageId: (uuid: string, id: number | null) => void;
  setHasNextPage: (uuid: string, hasNextPage: boolean) => void;
  setHasPrevPage: (uuid: string, hasPrevPage: boolean) => void;
  setIsInitialPageLoaded: (uuid: string, isLoaded: boolean) => void;
  setIsLoading: (uuid: string, isLoading: boolean) => void;
  setLastMessageId: (uuid: string, id: number | null) => void;
  setScrollInfo: (uuid: string, scrollInfo: ScrollInfo) => void;
  setTopMessageId: (uuid: string, id: number | null) => void;
}

export const messageUIActions = (
  set: (fn: (state: ChatRoomsSliceState) => void) => void,
): MessageUIActions => ({
  setIsLoading: (uuid, isLoading) =>
    set(state => {
      const chatRoomState = state.chatRoomStateMap.get(uuid);
      if (chatRoomState) {
        chatRoomState.uiState.isLoading = isLoading;
      }
    }),
  setIsInitialPageLoaded: (uuid, isLoaded) =>
    set(state => {
      const chatRoomState = state.chatRoomStateMap.get(uuid);
      if (chatRoomState) {
        chatRoomState.uiState.isInitialPageLoaded = isLoaded;
      }
    }),
  setHasNextPage: (uuid, hasNextPage) =>
    set(state => {
      const chatRoomState = state.chatRoomStateMap.get(uuid);
      if (chatRoomState) {
        chatRoomState.uiState.hasNextPage = hasNextPage;
      }
    }),
  setHasPrevPage: (uuid, hasPrevPage) =>
    set(state => {
      const chatRoomState = state.chatRoomStateMap.get(uuid);
      if (chatRoomState) {
        chatRoomState.uiState.hasPrevPage = hasPrevPage;
      }
    }),
  setScrollInfo: (uuid, scrollInfo) =>
    set(state => {
      const chatRoomState = state.chatRoomStateMap.get(uuid);
      if (chatRoomState) {
        chatRoomState.uiState.scrollInfo = scrollInfo;
      }
    }),
  setFirstMessageId: (uuid, id) =>
    set(state => {
      const chatRoomState = state.chatRoomStateMap.get(uuid);
      if (chatRoomState) {
        chatRoomState.uiState.firstMessageId = id;
      }
    }),
  setLastMessageId: (uuid, id) =>
    set(state => {
      const chatRoomState = state.chatRoomStateMap.get(uuid);
      if (chatRoomState) {
        chatRoomState.uiState.lastMessageId = id;
      }
    }),
  setTopMessageId: (uuid, id) =>
    set(state => {
      const chatRoomState = state.chatRoomStateMap.get(uuid);
      if (chatRoomState) {
        chatRoomState.uiState.topMessageId = id;
      }
    }),
  setActiveMessageId: (uuid, id) =>
    set(state => {
      const chatRoomState = state.chatRoomStateMap.get(uuid);
      if (chatRoomState) {
        chatRoomState.uiState.activeMessageId = id;
      }
    }),
});
